exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "healthcarebook-responsive-component .card-body img {\n  max-height: 550px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/health-care-book/responsive/responsive.css
// module id = 520
// module chunks = 0